import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { ProfileMenu } from './ProfileMenu';
// import { PWAPrompt } from './PWAPrompt';

export function Layout() {
    const location = useLocation();

    const getPageTitle = () => {
        switch (location.pathname) {
            case '/':
                return 'Dashboard';
            case '/time':
                return 'Time Tracker';
            case '/work-orders':
                return 'Work Orders';
            case '/expenses':
                return 'Expenses';
            case '/shifts':
                return 'Shifts';
            default:
                return 'Dashboard';
        }
    };

    return (
        <div className='min-h-screen bg-light dark:bg-dark'>
            <div className='fixed top-0 left-0 right-0 z-10 bg-light-card dark:bg-dark-card border-b border-light-border dark:border-dark-border'>
                <div className='max-w-4xl mx-auto px-4 py-3 flex justify-between items-center'>
                    <h1 className='text-xl font-semibold text-gray-900 dark:text-gray-100'>
                        {getPageTitle()}
                    </h1>
                    <ProfileMenu />
                </div>
            </div>
            <div className='pt-16 pb-20'>
                <Outlet />
            </div>
            <Navigation />
            {/* <PWAPrompt /> */}
        </div>
    );
}
